import { LitElement, html, css, ref, createRef  } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/all/lit-all.min.js';

const skioStyles = css`
  
  /* SECTION */
  .skio-subscribe-section {
    display: flex;
    gap: 2rem;
    align-items: center;
  }
  
  .skio-subscribe-section__image {
    min-height: 100%;
    width: 50%;
  }
  
  .skio-subscribe-section__image img {
    width: 70%;
    height: 100%;
    object-fit: cover;
    display: block;
    margin: auto;
  }
  
  .skio-subscribe-section__body {
    flex-grow: 1;
    max-width: 450px;
    padding: 1rem;
    margin: 1rem 0;
  }
  
  /* FORM */
  .skio-product-form__title {
    font-weight: 900;
    font-size: 30px;
    font-family: Helvetica;
    margin-bottom: 0;
  }
  
  .skio-product-form__product-select.skio-select {
    display: block;
    width: 100%;
    padding: 0.375rem 2.25rem 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    border: 1px solid #000;
    border-radius: 0;

    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
    appearance: none;
    
  }
  
  .skio-product-form__quantity {
    display: flex;
    border: 1px solid rgb(3, 3, 3);
    margin-bottom: 1rem;
    position: relative;
    display: flex;
    justify-content: flex-start;

    height: 45px;
    max-width: 185px;
  }

  .skio-minus {
    position: absolute;
    height: 22px;
    bottom: 0;
    right: 0;
    z-index: 3;
    margin-right: 0;
    width: 48px;
  }
  .skio-plus {
    position: absolute;
    min-height: 22px;
    top: 0;
    right: 0;
    z-index: 3;
    width: 48px;
  } 

  .skio-product-form__quantity button {
    background: transparent;
    font-size: 1.5rem;
    cursor: pointer;
    border: none;
    appearance: none;
  }

  .skio-product-form__quantity button svg {
    height: 0.65em;
    width: 0.65em;
  }
  
  .skio-product-form__quantity input {
    border: none;
    outline: none;
    width: calc(100% - 48px);
    text-align: center;
  }
  
  .skio-product-form__submit {
    border: none;
    outline: none;
    display: block;
    width: 100%;
    padding: .5rem .25rem;
    color: #fff;
    text-transform: uppercase;
    cursor: pointer;

    font-weight: bold;
    width: 100%;
    background-color: #80bc06;
    border-color: #80bc06;
    border-radius: 5px;
    font-family: Helvetica, 'Helvetica Neue', Arial, 'Lucida Grande', sans-serif;
    font-size: 15px;
  }
  .skio-product-form__submit:hover {
    
  }
  
  .skio-product-form__success {
    margin: 1rem 0;
  }
  
  .skio-select {
    display: block;
    width: 100%;
    padding: 0.5em 0.25em;
    font-size: 1rem;
    border: 1px solid rgb(3, 3, 3);
    margin-bottom: 1rem;
    
  }
 
  .skio-label {
    display: block;
  }
  
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    -moz-appearance: textfield;
  }

  .skio-sub-interval {
    font-weight: bold;
    margin: 0;
  }
  .skio-sub-interval + p {
    margin-top: 0;
  } 
  
  @media screen and (max-width: 992px) {
    .skio-subscribe-section {
      flex-wrap: wrap;
      padding: 0 1rem;
    }
    .skio-subscribe-section__image {
      width: 100%;  
    }
  }
`;

export class SkioProductUpsell extends LitElement {
  static properties = {
    title: {type: String },
    product: { type: Object },	
    collection: { type: Object },	
    key: { type: String }, 	
    quantity: { type: Number },	
    selectedVariant: { type: Object },
    
  };

  static styles = skioStyles;
  
  

  constructor() {
    super();
    // Define reactive properties--updating a reactive property causes the component to update.
    this.product = null;
    this.selectedVariant = null;
    this.collection = null;
    this.quantity = 1;

    this.key = null;
  }

  connectedCallback() {
    super.connectedCallback();
    this.product = this.collection[0];
    this.selectedVariant = this.collection[0].variants[0]
    this.key = this.product.id
  }

  planPickerRef = createRef();

  render() {
    return html`
      <div class="skio-subscribe-section">
        
        <div class="skio-subscribe-section__image">
          <img src="${ this.product.featured_image }" />
        </div>
        
        <div class="skio-subscribe-section__body skio-product-form">
          <h2 class="skio-product-form__title">${this.product.title}</h2>
          <p class="skio-sub-interval" skio-sub-interval>Delivery Every 2 Weeks</p>
          <p>$29.95</p>

          <div class="skio-product-form__quantity">
            <button class="skio-minus" @click="${ this.decreaseQty }" name="minus" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"> <g id="down-caret"> <path d="M96.4,25.73a2,2,0,0,0-2.82,0l-9.66,9.81a2,2,0,0,0-.78.47L50,69.17,16.86,36a2,2,0,0,0-.78-.47L6.42,25.75a2,2,0,1,0-2.84,2.81l45,45.69a2,2,0,0,0,2.84,0l45-45.69A2,2,0,0,0,96.4,25.73Z"></path></g></svg>
            </button>
            <input name="quantity" type="number" min="1" .value="${ this.quantity }" ${ref(this.quantityInput)}>
            <button class="skio-plus" @click="${ this.increaseQty }" name="plus" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"> <g id="up-caret"> <path d="M96.42,71.44l-45-45.69a2.05,2.05,0,0,0-2.84,0l-45,45.69a2,2,0,1,0,2.84,2.81l9.66-9.81a2,2,0,0,0,.78-.47L50,30.83,83.14,64a2,2,0,0,0,.78.47l9.66,9.81a2,2,0,0,0,1.42.6,2,2,0,0,0,1.42-3.41Z"></path></g></svg>
            </button>
          </div>
          
          <select class="skio-product-form__product-select skio-select" @change=${ (e) => this.selectProduct(e) }>
            <option>
              Select Flavor
            </option>
            ${ this.collection ? this.collection.map((product) =>
                  html`
                    <option value="${ product.id }">
                      ${ product.title.replace('HIGH PROTEIN ICED COFFEE -', "") }
                    </option>
                  `
                ) : 'no collection'
              }
          </select>
            
          <skio-plan-picker ${ref(this.planPickerRef)} .product='${ this.product }' .selectedVariant='${ this.selectedVariant }'></skio-plan-picker>
          
          ${ this.product.variants.length > 1 ? html`
            <!-- <label class="skio-label" for="${'skio-variant-'+this.key}">Variant:</label> -->
            <select 
              class="skio-product-form__variant-select skio-select" 
              @change=${ (e) => this.selectVariant(e) }
              id="${'skio-variant-'+this.key}"
            >
              <option>
                Frequency
              </option>
              ${ this.product.variants.length > 1 ? this.product.variants.map((variant, index) =>
                  html`
                    <option value="${ variant.id }">
                      ${ variant.title }
                    </option>
                  `
                ) : 'no collection'
              }
            </select>
          ` : '' }

          <button 
            class="skio-product-form__submit"
            @click="${ this.addToCart }"
          >Subscribe Now</button>
      </div>
    `
  }

  updated = (changed) => {
    this.addEventListener('skio:update-selling-plan', (e) => {
      let interval = e.detail.name
      this.renderRoot.querySelector('[skio-sub-interval]').innerHTML = interval;
    });
  }

  selectProduct(e) {
    this.product = this.collection.find(product => product.id == e.target.value);
    this.selectedVariant = this.product.variants[0]
  }

  selectVariant(e) {
    this.selectedVariant = this.product.variants.find(variant => variant.id == e.target.value)
  }

  addToCart() {
    this.showSuccess = false
    this.planPickerRef.value.addToCart(this.quantity).then(() => {
      window.location.href = '/cart'
    })
  }

  quantityInput = createRef()
  
  increaseQty() {
    this.quantity += 1
    this.quantityInput.value.value = this.quantity
  }

  decreaseQty() {
    if (this.quantity != 1) this.quantity -= 1
    this.quantityInput.value.value = this.quantity
  }
}

customElements.define('skio-product-upsell', SkioProductUpsell);